import { action, computed, observable } from 'mobx'
import PT from 'prop-types'

import {
  CALENDAR_VIEW,
  SIMPLIFIED_VIEW,
} from '#utils/booking'

const mkStore = (
  _request,
  { onSubmit }
) => {
  const store = observable({
    _simplifiedChecked: false,
    _calendarChecked: false,

    simplifiedChecked: computed(() =>
      store._simplifiedChecked
    ),
    calendarChecked: computed(() =>
      store._calendarChecked
    ),
    handleCheckSimplified: action(() => {
      store._simplifiedChecked = !store._simplifiedChecked
      if (store._simplifiedChecked) {
        store._calendarChecked = false
      }
    }),
    handleCheckCalendar: action(() => {
      store._calendarChecked = !store._calendarChecked
      if (store._calendarChecked) {
        store._simplifiedChecked = false
      }
    }),
    handleSimplifiedSubmit: action(() => {
      onSubmit(SIMPLIFIED_VIEW, store.simplifiedChecked)
    }),
    handleCalendarSubmit: action(() => {
      onSubmit(CALENDAR_VIEW, store.calendarChecked)
    }),
  })

  return store
}

mkStore.propTypes = {
  onSubmit: PT.func.isRequired,
}

mkStore.contextTypes = {}

mkStore.propTypes = {}

export default mkStore
